import React from 'react';
import PropTypes from 'prop-types';
import { CardActions } from 'material-ui/Card';
import { LinearProgress } from 'material-ui';
import { push } from 'react-router-redux';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import { connect } from 'react-redux';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import { CreateButton, RefreshButton, WithPermission } from 'admin-on-rest';
import fileDownload from 'js-file-download';
import { DateTime } from 'luxon';
import { URL_PROJECT_EXPORT } from '../constants';
import fetcher from '../helpers/fetcher';
import { getDateTimeForFilename } from '../helpers/date';

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right'
};

class ProjectActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showExportForm: false
    };
  }

  _onShowExportForm = () => this.setState({ showExportForm: true });

  _onSelectUpdatedAtAfter = (e, value) => {
    this.setState({
      contactUpdatedAtAfter: value
    });
  };

  _onSelectUpdatedAtBefore = (e, value) => {
    this.setState({
      contactUpdatedAtBefore: DateTime.fromJSDate(value)
        .endOf('day')
        .toJSDate()
    });
  };

  _onStatsClick = () => {
    this.timeoutId = setTimeout(
      () =>
        this.props.navigate(
          '/stats/' + (this.props.filterValues.id || []).join(',')
        ),
      10
    );
  };

  _onExportClick = () => {
    this.setState({ loading: true });
    fetcher
      .post(
        `${URL_PROJECT_EXPORT}`,
        {
          projectId: this.props.filterValues.id || [-1],
          ...(this.state.contactUpdatedAtAfter
            ? { contactUpdatedAtAfter: this.state.contactUpdatedAtAfter }
            : {}),
          ...(this.state.contactUpdatedAtBefore
            ? { contactUpdatedAtBefore: this.state.contactUpdatedAtBefore }
            : {})
        },
        { responseType: 'blob' }
      )
      .then(response => {
        fileDownload(
          response.data,
          'export_multi_' +
            (this.props.filterValues.id || []).join('_') +
            '_' +
            getDateTimeForFilename() +
            '.xlsx'
        );
        this.setState({ loading: false });
        this.props.showNotification('File exported.');
      });
  };

  render() {
    const {
      resource,
      filters,
      displayedFilters,
      filterValues,
      basePath,
      showFilter
    } = this.props;
    const hasSelectedProjects = (this.props.filterValues.id || []).length > 0;
    return (
      <CardActions style={cardActionStyle}>
        {filters &&
          React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button'
          })}
        <WithPermission
          // value={permission => ['admin', 'customer'].indexOf(permission) >= 0}
          value={'admin'}
        >
          <CreateButton basePath={basePath} />
        </WithPermission>
        <WithPermission
          value={['admin', 'customer']}
        >
          {/* Add your custom actions */}

          {hasSelectedProjects && (
            <FlatButton
              primary
              label="Stats For Projects In Filter"
              onClick={this._onStatsClick}
            />
          )}
          {!this.state.showExportForm && (
            <FlatButton
              primary
              label="Show Export"
              onClick={this._onShowExportForm}
            />
          )}
          {this.state.showExportForm && (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center'
              }}
            >
              <DatePicker
                hintText="Start Date"
                container="inline"
                source="contactUpdatedAtAfter"
                onChange={this._onSelectUpdatedAtAfter}
              />
              <DatePicker
                hintText="End Date"
                container="inline"
                source="contactUpdatedAtBefore"
                onChange={this._onSelectUpdatedAtBefore}
              />
              <RaisedButton
                primary
                label="Export Filtered Projects"
                onClick={this._onExportClick}
              />
            </div>
          )}
          {this.state.loading && <LinearProgress />}
        </WithPermission>
        <RefreshButton />
      </CardActions>
    );
  }
}

ProjectActions.propTypes = {
  resource: PropTypes.string,
  filters: PropTypes.object,
  displayedFilters: PropTypes.object,
  filterValues: PropTypes.object,
  basePath: PropTypes.string,
  showFilter: PropTypes.func,
  navigate: PropTypes.func,
  showNotification: PropTypes.func
};
export default connect(
  state => ({
    loading: state.admin.loading
  }),
  {
    showNotification: showNotificationAction,
    navigate: push
  }
)(ProjectActions);



// WEBPACK FOOTER //
// ./src/components/ProjectActions.js